<template>
  <div>
    <div class="common-header">
      <div class="common-header-right">
        <div class="common-header-block">
          <div style="padding-top: 15px">
            <el-button type="primary" @click="showEditFunc(1,type)">新增</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="common-header">
      <div class="common-header-left">
        <el-radio-group class="common-el-radio-group" v-model="type" @change="getList()">
          <el-radio-button label="21">短牌</el-radio-button>
          <el-radio-button label="61">德州</el-radio-button>
          <el-radio-button label="91">奥马哈</el-radio-button>
          <el-radio-button label="31">AOF</el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <div class="common-table">
      <el-table v-loading="loading" :data="firstList" height="100%" row-key="id">
          <el-table-column v-if="shortCardShow(type)" align="center" label="前注" prop="blindnote">
            <template slot-scope="scope">{{scope.row.blindnote | maxBetValue}}</template>
          </el-table-column>
          <el-table-column v-if="!shortCardShow(type)" align="center" label="盲注" prop="blindnote">
            <template slot-scope="scope">{{scope.row.blindnote | nodeNumber}}</template>
          </el-table-column>
          <el-table-column align="center" label="收取服务费比率" prop="pump">
            <template slot-scope="scope">{{scope.row.pump | pumpNumber}}</template>
          </el-table-column>
          <el-table-column align="center" label="封顶值" prop="maxbet">
            <template slot-scope="scope">{{scope.row.maxbet | maxBetValue}}</template>
          </el-table-column>
          <el-table-column align="center" label="房间" prop="pattern">
            <template slot-scope="scope">{{scope.row.pattern | patternTypeName}}</template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="showEditFunc(2,scope.row)">编辑</el-button>
              <el-button type="danger" size="mini" @click="deleteEdit(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
      </el-table>
    </div>
    <div v-if="show" v-show="show"  class="common-popup-bg">
      <div class="common-popup" style="width: 450px">
        <h3>{{form.op===1 ? '新增服务费':'修改服务费'}}</h3>
        <el-form ref="AoMaRuleForm" size="medium" :model="form" :rules="rules" class="common-popup-table"
                 label-width="100px">
          <el-form-item label="服务费率:" prop="pump" >
            <el-input type="number" resize="none" v-model="form.pump" placeholder="收取服务费比率%"/>
          </el-form-item>
          <el-form-item label="封顶值：" prop="maxbet">
            <el-input type="number" resize="none" v-model="form.maxbet" placeholder="封顶值"/>
          </el-form-item>
          <el-form-item v-if="!shortCardShow(type)" label="盲注：" prop="blindnote">
            <el-input type="text" resize="none" v-model="form.blindnote" placeholder="小盲/大盲"/>
          </el-form-item>
          <el-form-item v-if="shortCardShow(type)" label="前注：" prop="blindnote">
            <el-input type="number" resize="none" v-model="form.blindnote" placeholder="前注"/>
          </el-form-item>
          <el-form-item label="房间：" prop="pattern">
            <el-select v-model="form.pattern">
              <el-option
                  v-for="item of patternOptions"
                  :key="item.label"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item label="牌局类型：" prop="type">
            <strong v-text="`${roomType(form.type)}`"></strong>
          </el-form-item>

        </el-form>
        <footer>
          <el-button size="small" @click="close('AoMaRuleForm')">取消</el-button>
          <el-button size="small" type="primary" @click="submitForm('AoMaRuleForm')">确定</el-button>
        </footer>
      </div>
    </div>
  </div>

</template>
<script>
import {mapActions, mapGetters, mapState} from 'vuex'
export default {
  data() {
    return {
      id: null,
      type: 61,
      show: false,
      loading: false,
      list: [],
      form: {
        op: null,// 新增：1 编辑：2
        blindnote: '',
        id:'',
        pump: '',
        maxbet: '',
        type: 61
      },
      rules: {
        pump: [
          {required: true, message: '请输入服务费', trigger: 'blur'},
        ],
        type: [
          {required: true, message: '请选择游戏类型', trigger: 'blur'},
        ],
        pattern: [
          {required: true, message: '请选择游戏房间', trigger: 'blur'},
        ]
      },
      patternOptions: [// 游戏类型
        {label: '小型房间', value: '0'},
        {label: '中型房间', value: '1'},
        {label: '大型房间', value: '2'},
      ],
      formGameTypeOptions:[// 游戏类型
        {label: '奥马哈', value: 91},
        {label: '德州', value: 61},
        {label: 'AOF', value: 31},
        {label: '短牌', value: 21}
      ]
    }
  },
  computed:{
    ...mapState('login', ['permissions']),
    ...mapGetters('pumping', ['getPump']),
    firstList(){
      return this.list;
    },
  },
  created() {
    this.id = this.$route.query.id;
    this.getList();
  },
  filters:{
    nodeNumber(val){
      const str = val.split('/');
      return str[0]/100+'/'+str[1]/100;
    },
    pumpNumber(val){
      return val*100+'%';
    },
    maxBetValue(val){
      return val/100;
    },
    patternTypeName(type){
      switch (type){
        case 0: return '小型房间';
        case 1: return '中型房间';
        case 2: return '大型房间';
      }
    }
  },
  methods: {
    ...mapActions('user', ['checkUser']),
    ...mapActions('pumping', ['getPumpingList', 'addPumping', 'updatePumping', 'deletePumping']),
    arraySpanMethod({row, columnIndex}) {
      if (columnIndex === 0) {
        return {
          rowspan: row.rowspan,
          colspan: row.colspan
        };
      }
    },
    shortCardShow(val){
      return val==21;
    },
    getList() {
      this.loading = true;
      this.getPumpingList(this.type).then(res => {
            this.loading = false;
            this.list = res.data;
            this.close(res);
          }
      )
    },
    nodeNumberNote(val){
      const str = val.split('/');
      return str[0]/100+'/'+str[1]/100;
    },
    deleteEdit(id){
      this.deletePumping(id).then(()=>{
        this.$message.success('删除成功');
        this.getList();
      })
    },
    showEditFunc(op=1, obj = null) {
      this.form.op = op;
      if (op === 2) {
        this.form = Object.assign({}, this.form, {
          id:obj.id,
          blindnote: this.nodeNumberNote(obj.blindnote),
          pump: (obj.pump*100),
          pattern:obj.pattern,
          maxbet: (obj.maxbet/100),
          type: obj.type
        })
      } else {
        this.form = Object.assign({}, this.form, {
          type: obj
        })
      }
      this.show = true;
    },
    spilBlindnote(val){
      const str = val.split('/');
      return str[0]*100+'/'+str[1]*100;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let {op, ...params} = this.form;
          if (op === 1) {
            if (params.type==21){
              params.blindnote=params.blindnote*100
            }else {
              params.blindnote=this.spilBlindnote(params.blindnote);
            }
            params.pump=params.pump/100;
            params.maxbet=params.maxbet*100;
            this.addPumping(params).then(() => {
              this.$message.success('添加成功');
              this.getList();
              this.close(formName)
            })
          } else if (op===2){
            if (params.type==21){
              params.blindnote=params.blindnote*100
            }else {
              params.blindnote=this.spilBlindnote(params.blindnote);
            }
            params.pump=params.pump/100;
            params.maxbet=params.maxbet*100;
            this.updatePumping(params).then(() => {
              this.$message.success('修改成功');
              this.getList();
              this.close(formName)
            })
          }
        }
      });
    },
    roomType(type){
      var val1;
      switch (type) {
        case '61':
          val1="德州";
          break;
        case '91':
          val1= "奥马哈";
          break;
        case '31':
          val1= "AOF";
          break;
        case '21':
           val1= "短牌";
          break;
      }
      console.log(val1);
      return val1;
    },
    close(formName) {
      if (this.$refs[formName] !== undefined) {
        this.$refs[formName].resetFields();
      }
      this.show = false;
    }
  }
}
</script>